import React, { useContext} from "react";
import "./SafeAggrement.scss";
import "../../components/TypesInvestor/tyesInvestor.scss";
import parser from "html-react-parser";
import { Context } from "../../contextApi/contextProvider";
interface Safe {
  currentStep: number;
  htmlStrRemoved: string[];
  htmlStr: string[];
  formData: any;
  debouncedSave: Function;
  condition?: boolean;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const SafeAggrement = ({
  currentStep,
  htmlStr,
  htmlStrRemoved,
  formData,
  setFormData,
  debouncedSave,
  condition = false,
}: Safe) => {
    const { userLoginData, setAccessDoc, setUserLoginData, accessDoc } =  useContext(Context);
  const contents = [
    "PREAMBLE",
    "1. DEFINITIONS",
    "2. INVESTMENT & CONVERSION",
    "3. RIGHTS & RESTRICTIONS",
    "4. USE OF FUNDS",
    "5. REPRESENTATIONS & WARRANTIES",
    "6. MISCELLANEOUS",
    "7. SIGNATURES",
    "8. INVESTOR DECLARATION AND ACKNOWLEDGEMENT",
    "APPENDIX A: KEY TERMS",
    "SAFE APPLICATION FORM - ticca.ltd ",
    "FINAL DECLARATION & SIGNATURE",
  ];

  return (
    <>
       {htmlStr.length &&  <div className="watermaring-main-dev">
        <img
          src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
          alt="logo"
        />
        <p>
          Commercial in Confidence <br />
          Content under NDA.
          <br /> {userLoginData?.email}
        </p>
      </div> }
      {!condition && (
        <p
          className="termsandcondition"
          style={{ color: "white", margin: "auto", textAlign: "center" }}
        >
          Click{" "}
          <samp style={{ color: "rgba(7, 121, 220, 1)" }}>
            <b>“I agree”</b>
          </samp>{" "}
          at the end of the document to proceed to{" "}
          <b style={{ color: "" }}>Next</b> step
        </p>
      )}
      {htmlStrRemoved.length > 2 && (
        <div className="shareholder-main-dev">
          <div className="safe-agreement-container">
            {/* Header */}
            <div className="header">
              <h1>SAFE</h1>
              <p>SIMPLE AGREEMENT for FUTURE EQUITY</p>
            </div>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>TABLE OF CONTENTS</h2>
              <ul>
                {contents.map((item, index) => (
                  <li key={index}>
                    <div className="line">
                      <span className="title">{item}</span>
                      <span className="dots"></span>
                      <span className="page-number">{3 + index}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="safe-agreement-container">
            {htmlStr.length > 1 &&
              htmlStr.slice(0, 10).map((elem, index) => (
                <div
                  key={`table-of-contentsr-${index}`}
                  className="safe-agreement-cms-container"
                >
                  {index !== 9 && parser(elem)}
                  {index === 9 && (
                    <>
                      <h4>APPENDIX A: KEY TERMS</h4>
                      <div className="table-wrapper">
                        <table className="info-table">
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{htmlStrRemoved[84]}</td>
                              <td>{htmlStrRemoved[85]}</td>
                            </tr>
                            <tr>
                              <td>{htmlStrRemoved[86]}</td>
                              <td>{htmlStrRemoved[87]}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}

      {htmlStrRemoved.length > 2 && !condition && (
        <div
          style={{ margin: "10px auto", padding: "10px 70px" }}
          className="amount-investor-container"
        >
          {
            <div className="amount-investor-dividend-option">
              <div>
                <input
                  checked={formData?.SafeAgreementTermsAndCondition}
                  onChange={(e) => {
                    const value = e.target.checked ? htmlStrRemoved[9] : "";
                    if (condition) return;
                    setFormData((prev: any) => {
                      const updated = {
                        ...prev,
                        SafeAgreementTermsAndCondition: value,
                      };
                      debouncedSave(updated);
                      return updated;
                    });
                  }}
                  type="checkbox"
                />

                <label
                  style={{
                    fontFamily: "var(--Inter-Regular)",
                    transform: "translateY(1px)",
                    color:"white"
                  }}
                >
                  {htmlStr[9] && parser(htmlStr[9])}
                </label>
              </div>
            </div>
          }
        </div>
      )}
      {htmlStrRemoved.length > 2 && (
        <p className="termsandcondition">
          <b>{htmlStrRemoved[10]}</b>
        </p>
      )}
    </>
  );
};

// 🧠 Prevent re-renders unless props actually change
export default SafeAggrement;
